import { ArrowUpRight, ChevronLeft, ChevronRight, Megaphone } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';

type Placement = 'gallery' | 'palettes' | 'tutorials' | 'products';
interface Promotion {
  id: string;
  placement: Placement;
  title: string;
  eyebrow: string;
  imageData: string;
  targetType: 'operation' | 'url';
  targetValue: string;
  enabled: boolean;
}

export function HeroPromotionCarousel({ placement }: { placement: Placement }) {
  const [items, setItems] = useState<Promotion[]>([]);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/promotions', { signal: controller.signal, cache: 'no-store' })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => setItems((data?.promotions || []).filter((item: Promotion) => item.placement === placement && item.enabled)))
      .catch(() => undefined);
    return () => controller.abort();
  }, [placement]);
  useEffect(() => { setIndex(0); }, [items.length, placement]);
  useEffect(() => {
    if (items.length < 2) return;
    const timer = window.setInterval(() => setIndex((value) => (value + 1) % items.length), 6000);
    return () => window.clearInterval(timer);
  }, [items.length]);
  const item = useMemo(() => items[index], [index, items]);
  if (!item) return null;
  const href = item.targetType === 'url' ? item.targetValue : `#operation/${encodeURIComponent(item.targetValue)}`;
  return <aside className="hero-promotion" aria-label="招商合作">
    <a href={href || undefined} target={item.targetType === 'url' ? '_blank' : undefined} rel={item.targetType === 'url' ? 'noreferrer' : undefined} style={{ backgroundImage: item.imageData ? `linear-gradient(180deg,rgba(18,25,37,.06),rgba(18,25,37,.78)),url("${item.imageData}")` : undefined }}>
      <span><Megaphone size={14} />{item.eyebrow || '招商合作'}</span>
      <strong>{item.title || '了解合作计划'}</strong>
      <small>查看详情 <ArrowUpRight size={14} /></small>
    </a>
    {items.length > 1 && <div className="hero-promotion-controls"><button type="button" onClick={() => setIndex((index - 1 + items.length) % items.length)} aria-label="上一张招商内容"><ChevronLeft size={16} /></button><span>{items.map((entry, itemIndex) => <i className={itemIndex === index ? 'active' : ''} key={entry.id} />)}</span><button type="button" onClick={() => setIndex((index + 1) % items.length)} aria-label="下一张招商内容"><ChevronRight size={16} /></button></div>}
  </aside>;
}
